// extracted by mini-css-extract-plugin
export default {"renameIcon":"TagsModalContent-renameIcon-cVYe8","message":"TagsModalContent-message-zRYdW","result":"TagsModalContent-result-poJQI"};